import * as React from 'react';
import { SVGProps } from 'react';
const SvgSubtract = (props: SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 556 608"
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="currentColor"
        {...props}
    >
        <path d="M501 241v110H1V241h500z" />
    </svg>
);
export default SvgSubtract;
